/* External Deps */
import { FC, ReactElement, useState } from "react";
import { Stack } from "@mui/material";

/* Internal Deps */
import CertificateManagement from "./certificate-management";
import CertificateDetailModal from "./certificate-detail";
import UploadModal from "./upload-modal";
import EditCertificateModal from "./edit-certificate-modal";

const CertificateOfOrigin: FC = (): ReactElement => {
  const [uploadModalOpen, setUploadModalOpen] = useState<boolean>(false);
  const [detailModalOpen, setDetailModalOpen] = useState<boolean>(false);
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [selectedCertificateId, setSelectedCertificateId] = useState<string | null>(null);

  const handleUploadClick = () => {
    setUploadModalOpen(true);
  };

  const handleViewCertificate = (certificateId: string) => {
    setSelectedCertificateId(certificateId);
    setDetailModalOpen(true);
  };

  const handleEditCertificate = (certificateId: string) => {
    setSelectedCertificateId(certificateId);
    setEditModalOpen(true);
  };

  const handleUploadSuccess = () => {
    // The table will automatically refresh due to cache invalidation
    // Keep the modal open so users can view the results
    // Users can close it manually when they're done reviewing
  };

  const handleCloseDetailModal = () => {
    setDetailModalOpen(false);
    setSelectedCertificateId(null);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setSelectedCertificateId(null);
  };

  const handleEditSuccess = () => {
    setEditModalOpen(false);
    // The table will automatically refresh due to cache invalidation
  };

  return (
    <Stack sx={{ flex: 1 }}>
      <CertificateManagement
        onUploadClick={handleUploadClick}
        onViewCertificate={handleViewCertificate}
        onEditCertificate={handleEditCertificate}
      />

      <UploadModal
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
        onUploadSuccess={handleUploadSuccess}
        title="Upload Certificate"
        subtitle="Upload your Excel file to extract and store certificate data using AI processing."
      />

      <CertificateDetailModal
        open={detailModalOpen}
        onClose={handleCloseDetailModal}
        certificateId={selectedCertificateId}
        onEdit={() => {
          setDetailModalOpen(false);
          handleEditCertificate(selectedCertificateId!);
        }}
      />

      <EditCertificateModal
        key={selectedCertificateId}
        open={editModalOpen}
        onClose={handleCloseEditModal}
        certificateId={selectedCertificateId}
        onSuccess={handleEditSuccess}
      />
    </Stack>
  );
};

export default CertificateOfOrigin;